/**
 * Categorías y paginación del grid de productos.
 */

const DEFAULT_PER_PAGE = 20;

function paginationEls($, category) {
	const $container = $(`.productos-container[data-category="${category}"]`);
	return {
		$container,
		$pagination: $container.find('.productos-pagination'),
		$cards: $container.find('.productos-grid .producto-card'),
	};
}

function initProductsPaginationEvents(win, $) {
	if (win._posknProductsPaginationBound) return;
	win._posknProductsPaginationBound = true;

	$(document).on('change', '#category-select', function onCategoryChange() {
		win.cambiarCategoria($(this).val());
	});

	$(document).on('click', '.pagination-prev', function onPrevPage(e) {
		e.preventDefault();
		win.posknChangePage(-1);
	});

	$(document).on('click', '.pagination-next', function onNextPage(e) {
		e.preventDefault();
		win.posknChangePage(1);
	});

	$(() => {
		const categoriaInicial = $('#category-select').val();
		if (categoriaInicial) {
			win.cambiarCategoria(categoriaInicial);
		}
		win.setTimeout(() => {
			const cat = $('#category-select').val();
			if (cat) {
				win.posknInitPagination(cat);
			}
		}, 300);
	});
}

export function attachProductsPaginationGlobals(win, $) {
	win.posknCurrentPage = win.posknCurrentPage || {};
	win.posknProductsPerPage = win.posknProductsPerPage || DEFAULT_PER_PAGE;

	initProductsPaginationEvents(win, $);

	win.cambiarCategoria = function cambiarCategoria(categoria) {
		$('.productos-container').removeClass('active').hide();

		const $targetContainer = $(`.productos-container[data-category="${categoria}"]`);
		if ($targetContainer.length) {
			$targetContainer.addClass('active').show();
		} else {
			console.warn('No se encontró contenedor para categoría:', categoria);
			$('.productos-container').first().addClass('active').show();
		}

		$('#buscar-productos').val('');
		if (typeof win.posknHideSearchEmpty === 'function') {
			win.posknHideSearchEmpty();
		}
		if (typeof win.posknResetBusquedaIndices === 'function') {
			win.posknResetBusquedaIndices();
		}
		$('.producto-card')
			.show()
			.css({
				border: '1px solid #e0e0e0',
				'box-shadow': 'none',
				'background-color': '',
			})
			.removeClass('producto-seleccionado');

		win.setTimeout(() => {
			win.posknInitPagination(categoria);
		}, 100);

		$('#buscar-productos').focus();
	};

	win.posknInitPagination = function posknInitPagination(category) {
		const { $container, $pagination, $cards } = paginationEls($, category);
		if (!$container.length) return;

		$('.productos-pagination').hide();

		const totalProducts = $cards.length;
		const totalPages = Math.ceil(totalProducts / win.posknProductsPerPage);

		if (!win.posknCurrentPage[category]) {
			win.posknCurrentPage[category] = 1;
		}

		if (totalPages <= 1) {
			$pagination.hide();
			$cards.show();
			return;
		}

		$pagination.show();
		win.posknUpdatePagination(category, win.posknCurrentPage[category], totalPages);
		win.posknShowPage(category, win.posknCurrentPage[category]);
	};

	win.posknShowPage = function posknShowPage(category, page) {
		const { $cards } = paginationEls($, category);
		const start = (page - 1) * win.posknProductsPerPage;
		const end = start + win.posknProductsPerPage;

		$cards.hide();
		$cards.slice(start, end).show();
	};

	win.posknUpdatePagination = function posknUpdatePagination(category, currentPage, totalPages) {
		const { $pagination } = paginationEls($, category);
		$pagination.find('.page-info').text(`Página ${currentPage} de ${totalPages}`);
		$pagination.find('.pagination-prev').prop('disabled', currentPage <= 1);
		$pagination.find('.pagination-next').prop('disabled', currentPage >= totalPages);
	};

	win.posknChangePage = function posknChangePage(delta) {
		const category = $('#category-select').val();
		if (!category) return;

		const { $cards } = paginationEls($, category);
		const totalPages = Math.ceil($cards.length / win.posknProductsPerPage);
		const currentPage = win.posknCurrentPage[category] || 1;
		const newPage = currentPage + delta;

		if (newPage >= 1 && newPage <= totalPages) {
			win.posknCurrentPage[category] = newPage;
			win.posknShowPage(category, newPage);
			win.posknUpdatePagination(category, newPage, totalPages);
		}
	};
}
